<template>
  <assign-personal-panel
    ref="panel"
    :config="tabConfig"
    :users-loading="usersLoading"
  />
</template>

<script>
import AssignPersonalPanel from '../AssignPersonalPanel.vue'

const tabConfig = {
  endpoint: '/iso/application-reviewers',
  memberPlural: 'reviewers',
  addTitle: 'Add reviewer',
  addHint: 'Select a user, then add them to the review team',
  listTitle: 'Reviewers list',
  emptyTitle: 'No reviewers yet',
  emptySearchTitle: 'No matching reviewers',
  emptyHint: 'Add your first application reviewer above.',
  removeButtonTitle: 'Remove reviewer',
  loadError: 'Failed to load application reviewers',
  addError: 'Failed to add reviewer',
  addSuccess: 'Reviewer added successfully',
  removeTitle: 'Remove this reviewer?',
  removeSuccess: 'Reviewer removed',
  removeError: 'Failed to remove reviewer',
}

export default {
  name: 'ApplicationReviewersTab',
  components: {
    AssignPersonalPanel,
  },
  props: {
    usersLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tabConfig,
    }
  },
  methods: {
    fetchMembers() {
      return this.$refs.panel?.fetchMembers()
    },
  },
}
</script>
